import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { Loader } from '../shared/Loader';
import { MainLinkButton } from '../styled/buttons/MainLinkButton';
import { findVariantPrice } from '../../helpers/pages/collections/collectionsHelpers';
import axios from 'axios';

export default function BuyWithCredits(props) {
  const {
    variant,
    subscription,
    user,
    buttonSize = 'lg',
    buttonText,
    className,
    variantPrices,
    buyOrUpgrade = 'buy',
    displayAsReadonly = false,
    buttonTextSize,
    isOpen,
    subscriptionHasCredits
  } = props;

  const [status, setStatus] = useState('pending');
  const [buyStatus, setBuyStatus] = useState('pending');
  const [buyError, setBuyError] = useState(null);

  const handleBuyWithCreditsText = ` Credit${buttonText !== '1' ? 's' : ''}`;

  async function handleBuyWithCredits() {
    setBuyStatus('loading');
    try {
      await axios.post('/api/purchase_legacy', { user, variant });
      setBuyStatus('success');
      location.reload();
    }
    catch (e) {
      setBuyStatus('error');
      setBuyError(e?.response?.data?.message || 'An error has occured');
      return false;
    }
    return false;
  }

  function getCreditPrice(): number {
    if (variant.credit_price !== undefined && variant.credit_price !== null)
      return variant.credit_price;
    return findVariantPrice(
      variant,
      variantPrices,
      buyOrUpgrade === 'buy' ? 'credit' : 'upgradeCredit'
    ) as number;
  }

  function getDefaultButtonText(): string {
    const price = getCreditPrice();
    return `Buy with ${price} credit${price !== 1 ? 's' : ''}`;
  }

  if (getCreditPrice() < 1) {
    // This is simply a hack to ensure we don't accidentally ever show credit unlocks. This isn't ideal, because
    // We would be showing an "or" option without the button to some users.
    // Do not offer credit purchase for 0/-1 credit costs.
    return <></>;
  }

  const buyWithCreditsButton = isOpen
    ? '!bg-[#00A1E0] !text-white hover:!bg-[#24C1FF] !h-[56px]'
    : `rounded-[5px] px-5 flex align-middle items-center gap-2 justify-center bg-a-blue hover:bg-[#24C1FF] border-0 text-white ${
        buttonSize === 'lg' ? '!w-full' : '!w-[150px]'
      } uppercase ${
        buttonTextSize
          ? `text-[${buttonTextSize}px]`
          : buttonSize === 'lg'
          ? '!text-[17px]'
          : '!text-[14px]'
      } text-center font-[Eurostile] ${
        buttonSize === 'lg' && !isOpen ? ' !pt-[18px] !pb-[20px]' : '!py-2'
      } font-semibold`;

  return (
    <div className={className}>
      {!displayAsReadonly && (
        <>
          <MainLinkButton
            onClick={() => setStatus('confirming')}
            className={buyWithCreditsButton}
            size="full"
          >
            {buttonText || getDefaultButtonText()}
          </MainLinkButton>
          <p
            className={`${buttonSize === 'lg' ? 'py-3' : 'py-0.5'} text-a-light-gray font-normal ${
              buttonSize === 'lg' ? 'text-[14px]' : 'text-[12px]'
            }`}
          >
            * {subscription?.current_credit_balance || subscription?.legacy_current_credit_balance || 0} Credits Available
          </p>
        </>
      )}
      {displayAsReadonly && (
        <div className="flex gap-2 items-center">
          <div
            className={`rounded-[5px] p-0 flex align-middle items-center justify-center bg-[rgba(0, 0, 0, 0)] border-0 text-white text-center font-semibold text-[26px]`}
            // className={`rounded-[5px] p-0 flex align-middle items-center gap-2 justify-center bg-[rgba(0, 0, 0, 0)] border-0 text-white ${
            //   buttonSize === 'lg' ? '!w-full' : getCreditPrice() === 1 ? '!w-[160px]' : '!w-[172px]'
            // } uppercase ${
            //   buttonTextSize
            //     ? `text-[${buttonTextSize}px]`
            //     : buttonSize === 'lg'
            //     ? '!text-[17px]'
            //     : '!text-[14px]'
            // } text-center font-[Eurostile] font-semibold`}
          >
            {buttonText || getDefaultButtonText()}
          </div>
          <div className="flex text-[20px] font-light leading-[24px]">
            {handleBuyWithCreditsText}
          </div>
        </div>
      )}

      <Dialog
        open={status == 'confirming'}
        onClose={() => {
          setStatus('pending');
        }}
        className="relative z-50"
      >
        <div
          className="fixed inset-0 overflow-y-auto flex items-center justify-center bg-black/60"
          onClick={(e) => {
            const target = e.target as Element;
            if (!target.classList.contains('unlock-modal')) {
              setStatus('pending');
            }
          }}
        >
          <Dialog.Panel>
            <div className="unlock-modal bg-gray-800 shadow-lg drop-shadow-lg rounded-[5px] p-8">
              <div className="text-gray-500 text-[16px] pb-4">
                You will use <span className="text-white">{getCreditPrice()}</span> of{' '}
                <span className="text-white">{subscription?.legacy_current_credit_balance} Credits</span>
              </div>
              <button
                onClick={() => handleBuyWithCredits()}
                className="rounded-[5px] px-5 flex align-middle items-center gap-2 justify-center bg-a-blue border-0 text-white w-full uppercase text-[16px] text-center font-[Eurostile] py-2 font-semibold"
                disabled={buyStatus == 'loading' || buyStatus == 'success'}
              >
                {buyStatus == 'success' ? 'Purchase Completed' : 'Confirm Purchase'}
              </button>

              {buyStatus == 'error' && (
                <div className="text-red-500 text-[14px] pt-4">Error: {buyError}</div>
              )}
              {buyStatus == 'success' && (
                <div className="text-a-green text-[14px] pt-4">
                  The asset has been purchased successfully! The page will reload.
                </div>
              )}
              {buyStatus == 'loading' && <Loader />}
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </div>
  );
}
